export default __webpack_public_path__ + "static/renegade-ole-fashioned-thumbnail-cc9513589d0d978fcdd5190518c85c65.jpg";